import { getSearchParams } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { useEffect } from 'react';
import { useCurrentModule } from '../components';
import { resolveRecommendation } from './resolveRecommendation';
import { useAiRecommendationEnabled } from './useAiRecommendationEnabled';
const QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  useErrorBoundary: false
};
export const useEclipsePlanRecommendation = () => {
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    isEnabled
  } = useAiRecommendationEnabled();
  const {
    siteGuid
  } = getSearchParams();
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: tierData
  } = module.SDK.planRecommendationApiClient.hooks.useGetPlanRecommendationTier({
    siteGuid,
    p3Context
  }, isEnabled, QUERY_OPTIONS);
  const {
    data: bulletsData,
    isLoading: isBulletsLoading,
    isError
  } = module.SDK.planRecommendationApiClient.hooks.useGetPlanRecommendation({
    siteGuid,
    p3Context
  }, isEnabled, QUERY_OPTIONS);
  const recommendedProductId = (tierData == null ? void 0 : tierData.recommendedProductId) ?? '';
  const recommendedProductName = (tierData == null ? void 0 : tierData.recommendedProductName) ?? '';
  const siteName = (tierData == null ? void 0 : tierData.siteName) ?? '';
  useEffect(() => {
    if (isEnabled && recommendedProductId) {
      module.SDK.aiRecommendationStore.setRecommendedProductId(recommendedProductId);
    }
  }, [isEnabled, recommendedProductId, module]);
  const resolvedBullets = resolveRecommendation({
    data: bulletsData,
    recommendedProductName,
    t
  });
  return {
    recommendedProductId,
    recommendedProductName,
    siteName,
    bullets: (resolvedBullets == null ? void 0 : resolvedBullets.bullets) ?? [],
    isBulletsLoading: isEnabled && isBulletsLoading,
    isError: isEnabled && isError,
    isEnabled,
    isFallback: (bulletsData == null ? void 0 : bulletsData.isFallback) ?? false
  };
};
//# sourceMappingURL=useEclipsePlanRecommendation.js.map